import { optionsToStrategy } from '@/common/utils/optionsToStrategy'

export const options = [
  { label: 'Semanal', value: 'weekly' },
  { label: 'Quinzenal', value: 'fortnightly' },
  { label: 'Mensal', value: 'monthly' },
  { label: 'Intervalo Fixo', value: 'fixed' },
]

export const establishmentOptions = [
  { label: 'Semanal', value: 'weekly' },
  { label: 'Quinzenal', value: 'fortnightly' },
  { label: 'Mensal', value: 'monthly' },
]

export const strategy = optionsToStrategy(options)
export const establishmentStrategy = optionsToStrategy(establishmentOptions)
